<script setup lang="ts">
import BtnAppGallery from '@/assets/images/apps-page/app-gallery-badge.webp'
import BtnApple from '@/assets/images/apps-page/app-store-badge.webp'
import BtnGoogle from '@/assets/images/apps-page/google-play-badge.webp'

const APPS_LINKS = [
  {
    key: 'Apple',
    href: 'https://redirect.appmetrica.yandex.com/serve/818922990581394302',
    image: BtnApple,
  },
  {
    key: 'Google',
    href: 'https://redirect.appmetrica.yandex.com/serve/170404690310291845',
    image: BtnGoogle,
  },
  {
    key: 'AppGallery',
    href: 'https://redirect.appmetrica.yandex.com/serve/821010311468352718',
    image: BtnAppGallery,
  },
]
</script>

<template>
  <div class="apps-buttons">
    <nuxt-link
      v-for="link in APPS_LINKS"
      :key="link.key"
      :href="link.href"
      target="_blank"
      variant="transparent"
      class="apps-buttons__link"
    >
      <nuxt-img class="apps-buttons__image" :src="link.image" :alt="link.key" />
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.apps-buttons {
  display: flex;
  gap: 24px;

  &__link {
    width: 128px;
    height: 40px;
    color: var(--ui-text-primary);
  }

  &__image {
    width: 100%;
    height: 100%;
  }

  @include media('<desktop-mini') {
    flex-wrap: wrap;

    &__link {
      max-width: 150px;
      height: 47px;
    }
  }

  @include media('<tablet') {
    gap: 13px;

    &__link {
      width: 103px;
      height: 32px;
    }
  }
}
</style>
